<div class="header">
  <h3>{{'ZIP-FILE.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>

  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="company"
          [options]="company"
          [(ngModel)]="selectedCompany"
          (onChange)="filterBranchList()"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.COMPANY' | translate}}"
          [style]="{'z-index': 4}"
        >
        </p-dropdown>
        <label for="company">{{'FILTER.COMPANY' | translate}}</label>
      </div>

      <div class="row m-t-10">
        <div class="col-6">
          <div class="dropdown-label-group">
            <p-dropdown
              class="dv-dropdown"
              selectId="month"
              [options]="monthListDropdown"
              [(ngModel)]="selectedMonth"
              [autoDisplayFirst]="false"
              placeholder="{{'FILTER.MONTH' | translate}}"
            >
            </p-dropdown>
            <label for="month">{{'FILTER.MONTH' | translate}}</label>
          </div>
        </div>
        <div class="col-6">
          <div class="dropdown-label-group">
            <p-dropdown
              class="dv-dropdown"
              selectId="year"
              [options]="yearList"
              [(ngModel)]="selectedYear"
              [autoDisplayFirst]="false"
              placeholder="{{'FILTER.YEAR' | translate}}"
            >
            </p-dropdown>
            <label for="year">{{'FILTER.YEAR' | translate}}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="companyBranch"
          [options]="branchList"
          [(ngModel)]="selectedBranch"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.BRANCH' | translate}}"
          [style]="{'z-index': 4}"
        >
        </p-dropdown>
        <label for="companyBranch">{{'FILTER.BRANCH' | translate}}</label>
      </div>

      <div class="d-none">
        <p-autoComplete [(ngModel)]="branch" [disabled]="allBranch" field="full_name" [multiple]="true"
                        [suggestions]="branchSuggest" [size]="30" (completeMethod)="searchBranch($event)"
                        (onClear)="clearBranch()" class="dv-autocomplete" placeholder="{{'FILTER.BRANCH' | translate}}">
        </p-autoComplete>
      </div>

      <div class="m-t-10 d-none">
        <p-autoComplete [(ngModel)]="documentType" [disabled]="allDocType" field="type" [multiple]="true"
                        [suggestions]="typeSuggest" [size]="30" (completeMethod)="searchDocumentType($event)"
                        (onClear)="clearDocType()" class="dv-autocomplete" placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}">
        </p-autoComplete>
      </div>

<!--      <div class="dropdown-label-group m-t-10">-->
<!--        <p-dropdown-->
<!--          class="dv-dropdown"-->
<!--          selectId="zipOption"-->
<!--          [options]="canDownloadZipOption"-->
<!--          [(ngModel)]="selectedCanDownloadZip"-->
<!--          [autoDisplayFirst]="false"-->
<!--          placeholder="{{'ZIP-FILE.CHECKING-ACCOUNT' | translate}}"-->
<!--          [style]="{'z-index': 3}"-->
<!--        >-->
<!--        </p-dropdown>-->
<!--        <label for="zipOption">{{'ZIP-FILE.CHECKING-ACCOUNT' | translate}}</label>-->
<!--      </div>-->
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="documentType"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}"
        >
        </p-dropdown>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>

      <div class="row align-items-center" style="height: 50%">
        <div class="col-md-auto m-t-10">
          <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="notUploaded"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="notApprove">-->
          <span>{{'ZIP-FILE.ITEMS-NOT-DOWNLOADED' | translate}}</span>
        </div>
        <div class="col d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allBranch" binary="true" (onChange)="selectAllBranch()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allBranch" (change)="selectAllBranch()">-->
          <span>{{'COMMON.ALL-BRANCHES' | translate}}</span>
        </div>
      </div>
      <div class="row align-items-center" style="height: 50%;">
        <div class="col-md-auto d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allDocType" binary="true" (onChange)="selectDocType()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allDocType" (change)="selectDocType()">-->
          <span>{{'COMMON.ALL-TYPES-DOCUMENTS' | translate}}</span>
        </div>



      </div>
    </div>
  </div>
  <span *ngIf="errorMsg" style="color: #e74c3c;margin-right:10px">{{errorMsg}}</span>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    [maxSize]="5"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="no_data === false"
  >
    <div class="row align-items-center">
    <!--<button *ngIf="canUserDownloadDoc()" style="flex-grow:0;margin-left:10px;" type="button" class="btn btn-success" [disabled]="!canSelectAll()" (click)="selectAll()">-->
    <!--เลือกทั้งหมด-->
    <!--</button>-->
    <div>
      <button *ngIf="canUserDownloadDoc()" type="button" class="btn btn-dv btn-wide" [disabled]="!EnabledDownloadSelected()" (click)="DownloadSelected(content2)">
        {{'COMMON.DOWNLOAD' | translate}}
      </button>
    </div>
    <div class="col-auto v-divider" *ngIf="canUserDownloadDoc()"></div>
    <div>
      {{'ZIP-FILE.DOWNLOADED' | translate}}: <span class="progress-text">{{ getProgress() }}%</span>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-dv btn-wide" [disabled]="loading_excel_report" (click)="DownloadExcelReport()">
        <i *ngIf="loading_excel_report === true" class="fa fa-spinner fa-spin m-r-5"></i>
        Excel
      </button>
    </div>
  </div>
  </app-custom-pagination>

  <!--<div class="row m-t-20" *ngIf="loading === true">-->
    <!--<div class="col-12 text-center">-->
      <!--<i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>-->
    <!--</div>-->
  <!--</div>-->

  <div class="row m-t-20" *ngIf="no_data === true && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="m-t-20 text-center scrollable">
    <p-table #tt tableStyleClass="table" *ngIf="no_data === false" [loading]="loading"
             [columns]="tableCol" [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngIf="canUserDownloadDoc()">
            <p-checkbox class="dv-checkbox" binary="true" (onChange)="selectDeselectAll($event)"></p-checkbox>
          </th>
          <th scope="col">{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
            <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
          </th>
<!--          <th scope="col">{{'ZIP-FILE.VERIFIED-BY-ACCOUNT' | translate}}</th>-->
          <th scope="col" class="text-center">{{'ZIP-FILE.DOWNLOAD-FILE' | translate}} Zip</th>
          <th scope="col">{{'ZIP-FILE.DOWNLOAD-SUCCESS' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td *ngIf="canUserDownloadDoc()">
            <p-checkbox class="dv-checkbox" binary="true"
                        [(ngModel)]="selectedValues[index]"></p-checkbox>
          </td>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td class="d-none">{{data.group__name}}</td>
          <td>{{data.corporate_branch__name}}</td>
          <td>{{data.rd_document_type_display}}</td>
          <td class="d-none">{{data.document_type__type}}</td>
          <td>{{data.total_documents | number: '1.'}}</td>
<!--          <td>-->
<!--            <i *ngIf="data.can_download_zip === true" class="fa fa-check m-r-5"></i>-->
<!--          </td>-->
          <td class="text-center">
            <button class="btn btn-dv btn-clean btn-compact btn-wide" (click)="getExportDocs(data)">
              <i *ngIf="data.loading_zip" class="fa fa-spinner fa-spin m-r-5"></i>
              Zip
            </button>
          </td>
          <td>
              <i *ngIf="data.uploaded === true" class="fa fa-check m-r-5"></i>
            <!--<p-checkbox *ngIf="data.can_download_zip === true" name="groupname" [(ngModel)]="data.uploaded" binary="true"-->
                        <!--(click)="confirmDocument($event, content, index, data.uploaded)"></p-checkbox>-->
            <!-- <input disabled type="checkbox" name="free" *ngIf="data.uploaded === true" [checked]="data.uploaded === true" (change)="confirmDocument($event, content, index, data)"> -->
          </td>
        </tr>
        <!--<tr>-->
          <!--<td></td>-->
          <!--<td></td>-->
          <!--<td></td>-->
          <!--<td></td>-->
          <!--<td>รวม (ทุกหน้า)</td>-->
          <!--<td>-->
            <!--{{ sum_docs_count | number: '1.' }}-->
          <!--</td>-->
          <!--<td class="text-center">-->
          <!--</td>-->
          <!--<td>-->
          <!--</td>-->
          <!--<td>-->
          <!--</td>-->
        <!--</tr>-->
      </ng-template>
    </p-table>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h5>{{'COMMON.CONFIRM-TRANSACTION' | translate}}</h5>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" (click)="confirm()">{{'COMMON.OK' | translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" [disabled]="loading_all_zip" (click)="closeDownloadAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="margin-bottom: 10px">
      <div *ngIf="loading_all_zip" class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
        <br/>
        {{allZipCurrent}} / {{allZipCount}}
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <ngb-progressbar *ngIf="loading_all_zip === true" type="info" [value]="loading_all_zip_progress" height="20px"></ngb-progressbar>
        <span *ngIf="loading_all_zip === false" style="color: #4d5f7a">{{loading_all_zip_message}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="closeDownloadAll()">{{'COMMON.CLOSE' | translate}}</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/zip-file/zip-file.component.html